import { API_URL } from "../constants";
import { apiRequest } from "./apiRequest";

export const url = `${API_URL}/api/v1/dispositions`;

const getDispositionOptions = async () => await apiRequest(url, "get");

export default getDispositionOptions;
